<!--
 * @Author: hfxie
 * @Date: 2022-08-30 16:30:40
 * @LastEditors: haifeng_xie haifeng_xie@kingdee.com
 * @LastEditTime: 2023-10-20 11:08:43
 * @Description: 列表信息
-->
<template>
  <div
    class="list"
    :class="{
      'list-no-top': toolbarShow === false
    }"
    @scroll.passive="ScrollEvent($event)"
  >
    <div
      v-if="(f_data instanceof Array && f_data.length == 0)"
      class="list-panel-empty"
    >
      <div class="empty-content">
        <div class="empty-logo"></div>
        <div class="empty-info">{{this.$store.state.noDataMsg}}</div>
      </div>
    </div>
    <div
      v-else
      class="list-panel"
    >
      <div
        class="left-panel"
        :style="{
          'left': _left,
          'width': $store.state.local.leftWidth + 'px'
        }"
      >
        <ZoneLeft :list="f_data" :toolbarShow="toolbarShow"></ZoneLeft>
      </div>

      <div
        class="right-panel"
        :style="{
          'padding-left': $store.state.local.leftWidth + 'px'
        }"
      >
        <ZoneRight ref="zoneRight" :list="f_data" :header="f_header" :toolbarShow="toolbarShow"></ZoneRight>
      </div>
    </div>


  </div>
</template>

<script>
import ZoneLeft from "@/components/List/Zone/Left/Left";
import ZoneRight from "@/components/List/Zone/Right/Right";
export default {
  name: "List",
  data() {
    return {
      diffLeft: 0,
    };
  },
  props: {
    toolbarShow: {
      type: Boolean,
      default: () => {
        return true;
      },
    },

  },
  components: {
    ZoneLeft,
    ZoneRight,
  },
  computed: {
    f_header() {
      const showData = this.$store.state.data.list.header || {};
      return showData;
    },
    f_data() {
      // const showData = this.$store.getters.contentData;
      const sourceData = this.$store.state?.data?.list?.info || [];
      return sourceData;
    },
    _left() {
      return this.diffLeft + "px";
      // return `translateX(${this.diffLeft}px)`;
    },
  },
  methods: {
    ScrollEvent(el) {
      const _left = this.$el.scrollLeft;
      const _viewWidth = this.$store.state.local.totalWidth;
      const _maxWidth = this.$refs.zoneRight.$el.clientWidth > _viewWidth ? this.$refs.zoneRight.$el.clientWidth : _viewWidth;
      if (_left === this.diffLeft) {
        return; // console.log("横向没改变");
      }
      if (_maxWidth + 148 + 6 < _left + _viewWidth) {
        return; // console.log("超出 不需要更新");
      }
      this.diffLeft = _left;
    },
  },
};
</script>

<style scoped lang='less'>
  .list{
    height: calc(100% - 40px);
    &.list-no-top{
      height: 100%;
    }
    min-height: 560px;
    overflow: auto;
    background: #fff;
    font-size: 12px;
    position: relative;
    .list-panel-empty{
      width: 100%;
      height: 100%;
      text-align: center;
      .empty-content{
        width: 200px;
        height: auto;
        position: absolute;
        top: 50%;
        left: 0;
        right: 0;
        margin: 0 auto;
        transform: translateY(-50%);
        .empty-logo{
          width: 112px;
          height: 64px;
          background-image: url(../../assets/images/noData@2x.png);
          background-size: 100% 100%;
          margin: 0 auto 8px;
        }
        .empty-info{
          font-size: 14px;
          color: #999999;
          letter-spacing: 0;
          text-align: center;
          line-height: 20px;
        }
      }

    }
    .list-panel{
      position: relative;
      display: inline-block;
      background-color: #FFFFFF;
      min-width: 100%;
      .left-panel{
        width: @leftViewWidth;
        position:absolute;
        top: 0;
        left: 0;
        z-index: 4;
        // border-bottom: 1px solid purple;
        word-break: break-all;
        // background-color: greenyellow;
      }
      .right-panel{
        padding-left: @leftViewWidth;
        box-sizing: border-box;
        // border-bottom: 1px solid green;
        // background-color: purple;
      }
    }

  }

</style>
